import * as Vue from "vue-tsx-support";
import "vue-tsx-support/enable-check"
import iView from 'lb-iview'
import {VNode} from 'vue'

let IView: any = iView

export interface SpinProps {
	/**
	 * Spin尺寸，可选值为large和small或者不设置
	 */
	size?: 'large' | 'small';
	/**
	 * 是否固定，需要父级有relative或absolute
	 * @default false
	 */
	fix?: boolean;
	/**
	 * slot插槽对象
	 */
	$slots?: {
		/**
		 * 自定义 Spin 的内容，设置slot后，默认的样式不生效
		 */
		'': VNode[];
	};
}



const Spin = Vue.ofType<SpinProps,{onClick():void}>().convert(IView.Spin);
export default Spin


